import { FacetedCategoryDto } from '@marketplace-web/domain/catalog-data'

const generateNavStackReverse = (
  category: FacetedCategoryDto,
  targetId: number,
): Array<number> | undefined => {
  const categoryId = Number(category.id)

  if (categoryId === targetId && category.categories.length === 0) {
    return []
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const value of category.categories) {
    const ids = generateNavStackReverse(value, targetId)

    if (ids) {
      ids.push(categoryId)

      return ids
    }
  }

  return undefined
}

export const generateNavStack = (
  categories: Array<FacetedCategoryDto>,
  targetId: number,
): Array<number> | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  for (const cat of categories) {
    const found = generateNavStackReverse(cat, targetId)?.reverse()
    if (found) return found
  }

  return undefined
}

export const findCategory = (
  categories: Array<FacetedCategoryDto>,
  targetId: number,
): FacetedCategoryDto | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  for (const cat of categories) {
    if (Number(cat.id) === targetId) return cat

    const found = findCategory(cat.categories, targetId)
    if (found) return found
  }

  return undefined
}
